import React from "react";
import { Helmet } from "react-helmet";
import { Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import WhoWeAre from "./pages/WhoWeAre";
import WhatWeDo from "./pages/WhatWeDo";
import Products from "./pages/Products";
import SpecialOffers from "./pages/SpecialOffers";
import Contact from "./pages/Contact";

function App() {
  return (
    <>
      <Helmet>
        <title>RelyOnne UK Limited – Trusted Paper Supplier in the UK</title>
        <meta
          name="description"
          content="RelyOnne UK Limited is your one stop solution for all paper needs. Quality paper products, reliable supply, and great service."
        />
      </Helmet>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/who-we-are" element={<WhoWeAre />} />
        <Route path="/what-we-do" element={<WhatWeDo />} />
        <Route path="/products" element={<Products />} />
        <Route path="/special-offers" element={<SpecialOffers />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </>
  );
}

export default App;